export default __webpack_public_path__ + "static/media/calendar.6ae3ee0b.svg";